var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.haveBookingRequest
    ? _c(
        "div",
        [
          _c("div", { staticClass: "dashboard-page-title" }, [
            _c(
              "div",
              { staticClass: "container-fluid" },
              [
                _vm.booking && _vm.booking.campaign
                  ? _c("booking-campaign-banner", {
                      attrs: { campaign: _vm.booking.campaign },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "row flex align-center" }, [
                  _c("div", { staticClass: "col-sm-6" }, [
                    _c("h1", [
                      _vm._v(
                        _vm._s(_vm.$t("Request")) +
                          " #" +
                          _vm._s(_vm._f("padded")(_vm.booking.id, "0", 5))
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-sm-6" },
                    [_c("booking-status", { attrs: { booking: _vm.booking } })],
                    1
                  ),
                ]),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "container-fluid" },
            [
              _vm.$userIsClient
                ? _c("booking-request-progress", {
                    attrs: { booking: _vm.booking },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.$userIsTalent && _vm.$userIsActivated
                ? _c("booking-talent-response", {
                    attrs: { booking: _vm.booking },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.userCanSeeBookingResponses
                ? _c("booking-responses-list", {
                    attrs: { booking: _vm.booking },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.adminCanSeeTalentNotifications
                ? _c("booking-talent-notifications", {
                    attrs: {
                      booking: _vm.booking,
                      recommendations: _vm.recommendations,
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.$userIsAdmin &&
              _vm.bookingTypeIsBookingRequest &&
              _vm.bookingIsPending
                ? _c("booking-talent-recommendations", {
                    attrs: {
                      booking: _vm.booking,
                      recommendations: _vm.recommendations,
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.adminCanSeeTalentNotifications
                ? _c("booking-manager-notifications", {
                    attrs: { booking: _vm.booking },
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("booking-details", {
                attrs: {
                  booking: _vm.booking,
                  "property-mutator": _vm.setRequestProperty,
                },
              }),
              _vm._v(" "),
              _vm.$userIsAdmin ||
              _vm.$userIsClient ||
              ((_vm.$userIsTalent || _vm.$userIsManager) &&
                _vm.$showClientDetailsBookingModuleEnabled)
                ? _c("booking-client-details", {
                    attrs: { booking: _vm.booking },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.canViewRegionalAdminOptions && _vm.$billboardModuleEnabled
                ? _c("booking-tag-targeting", {
                    attrs: { booking: _vm.booking },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.$userIsAdmin
                ? _c("booking-notes", { attrs: { booking: _vm.booking } })
                : _vm._e(),
              _vm._v(" "),
              (!_vm.$vlastMode ||
                (_vm.monetaryCurrency && _vm.booking.budget_per_star > 0)) &&
              _vm.canViewRegionalAdminOptions
                ? _c("request-admin-options", {
                    attrs: {
                      booking: _vm.booking,
                      "property-mutator": _vm.setRequestProperty,
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.$userIsAdmin && !_vm.$vlastMode
                ? _c("booking-sales-pipeline", {
                    key: "1",
                    attrs: { booking: _vm.booking },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.$userIsAdmin
                ? _c("booking-history", { attrs: { booking: _vm.booking } })
                : _vm._e(),
              _vm._v(" "),
              !_vm.$vlastMode
                ? _c(
                    "div",
                    [
                      _vm.canViewRegionalAdminOptions
                        ? _c("booking-source", {
                            attrs: { booking: _vm.booking },
                          })
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.$userIsClient
                ? _c("booking-search-details-list", {
                    attrs: { booking: _vm.booking },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.$userIsAdmin || _vm.$userIsIntern
                ? _c("booking-download-pdf", {
                    attrs: { booking: _vm.booking },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.booking.can_upload_files
                ? _c("booking-upload-files", {
                    attrs: { booking: _vm.booking },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.canViewRegionalAdminOptions || _vm.$userIsClient
                ? _c(
                    "div",
                    { staticClass: "dashboard-block button-bank" },
                    [
                      _vm.userCanEditBookingRequest
                        ? _c(
                            "router-link",
                            {
                              staticClass: "btn btn-info",
                              attrs: {
                                to: {
                                  name: "requests.edit",
                                  params: { id: _vm.id },
                                },
                              },
                            },
                            [
                              _c("i", { staticClass: "fa fa-pencil" }),
                              _vm._v(
                                "   Edit " +
                                  _vm._s(
                                    !_vm.booking.is_offer
                                      ? _vm.$t("Request")
                                      : `Offer`
                                  ) +
                                  "\n      "
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.userCanDuplicateBookingRequest
                        ? _c(
                            "router-link",
                            {
                              staticClass: "btn btn-info",
                              attrs: {
                                to: {
                                  name: "requests.duplicate",
                                  params: { id: _vm.id },
                                },
                              },
                            },
                            [
                              _c("i", { staticClass: "fa fa-clone" }),
                              _vm._v(
                                "   Duplicate " +
                                  _vm._s(
                                    !_vm.booking.is_offer
                                      ? _vm.$t("Request")
                                      : `Offer`
                                  ) +
                                  "\n      "
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.userCanWithdrawBookingRequest
                        ? _c(
                            "ladda-button",
                            {
                              staticClass: "btn btn-danger",
                              attrs: {
                                click: _vm.handleWithdrawBookingRequestCallback,
                              },
                            },
                            [
                              _c("i", { staticClass: "fa fa-close" }),
                              _vm._v(
                                "   Withdraw " +
                                  _vm._s(
                                    !_vm.booking.is_offer
                                      ? _vm.$t("Request")
                                      : `Offer`
                                  ) +
                                  "\n      "
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.userCanReactivateBookingRequest
                        ? _c(
                            "ladda-button",
                            {
                              staticClass: "btn btn-info",
                              attrs: {
                                click:
                                  _vm.handleReactivateBookingRequestCallback,
                              },
                            },
                            [
                              _c("i", { staticClass: "fa fa-refresh" }),
                              _vm._v("  \n        "),
                              _vm.bookingIsDeclined
                                ? _c("span", [
                                    _vm._v(
                                      "Reactivate Pending " +
                                        _vm._s(
                                          !_vm.booking.is_offer
                                            ? _vm.$t("Request")
                                            : `Offer`
                                        )
                                    ),
                                  ])
                                : _c("span", [
                                    _vm._v(
                                      "Reactivate " +
                                        _vm._s(
                                          !_vm.booking.is_offer
                                            ? _vm.$t("Request")
                                            : `Offer`
                                        )
                                    ),
                                  ]),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c("request-client-withdraw-reason-modal", {
            ref: "modal",
            on: { input: _vm.handleWithdrawRequestReason },
          }),
          _vm._v(" "),
          _vm.$userIsAdmin || _vm.$userIsClient
            ? _c("booking-terms-and-conditions-modal-no-action", {
                attrs: { booking: _vm.booking },
              })
            : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }